import React from 'react';
import { Link } from 'react-router-dom';
import { ASSETS } from '@/lib/api';
import { FileText, Award, LifeBuoy, Calendar, BookOpen, ScrollText } from 'lucide-react';

const SECTIONS = [
  { icon: BookOpen, title: 'Student Support', body: 'Email support@trjacademy.com for any academic or technical question. Most replies within one business day.' },
  { icon: ScrollText, title: 'Academic Policies', body: 'Review attendance, assessment, and academic integrity standards expected of every TRJ Academy student.' },
  { icon: Award, title: 'Certificates & Records', body: 'Access all earned certificates and your academic record from your student dashboard, anytime.' },
  { icon: LifeBuoy, title: 'Support Tickets', body: 'Open a support ticket directly from your dashboard for technical, billing, or academic concerns.' },
  { icon: Calendar, title: 'Course Calendar', body: 'Track upcoming live sessions, assessment deadlines, and CE windows in one place.' },
  { icon: FileText, title: 'Downloads', body: 'Re-download program materials, syllabi, and certificates anytime.' },
];

export default function StudentServices() {
  return (
    <div data-testid="student-services-page" className="bg-trjlight">
      <section className="bg-navy text-white py-20 relative overflow-hidden">
        <div className="absolute inset-0 hero-grain opacity-50" />
        <div className="relative max-w-7xl mx-auto px-6 lg:px-8">
          <span className="trj-divider">Student Services</span>
          <h1 className="font-display font-semibold text-4xl lg:text-6xl mt-6 leading-tight">
            We support you, <span className="text-gold font-serif italic">end-to-end.</span>
          </h1>
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-6 lg:px-8 py-16">
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {SECTIONS.map((s) => {
            const Icon = s.icon;
            return (
              <div key={s.title} className="card-elevate bg-white border border-slate-200 rounded-xl p-6">
                <div className="h-11 w-11 rounded-md bg-navy/5 text-navy flex items-center justify-center">
                  <Icon className="h-5 w-5" />
                </div>
                <h3 className="font-display font-semibold text-lg text-navy mt-4">{s.title}</h3>
                <p className="text-sm text-slate-600 mt-2 leading-relaxed">{s.body}</p>
              </div>
            );
          })}
        </div>

        <div className="mt-16 grid lg:grid-cols-2 gap-10 items-center bg-white border border-slate-200 rounded-2xl p-10">
          <img src={ASSETS.student} alt="" loading="lazy" decoding="async" className="rounded-xl" onError={(e) => { e.currentTarget.style.display = 'none'; }} />
          <div>
            <h2 className="font-display font-semibold text-2xl text-navy">Access your portal</h2>
            <p className="text-slate-600 mt-3">Log in to your student dashboard to view your courses, progress, certificates, and to open support tickets.</p>
            <Link to="/dashboard" className="inline-block mt-6">
              <button className="btn-navy h-11 px-6 rounded-md font-semibold" data-testid="open-dashboard">Open Dashboard</button>
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}
